import PhotoSwipeLightbox from "photoswipe/lightbox";
import "photoswipe/style.css";
import React, { useEffect } from "react";
import { Button } from "react-bootstrap";
const CertificateModal = (props) => {
  useEffect(() => {
    let lightbox = new PhotoSwipeLightbox({
      gallery: "#" + props.galleryID,
      children: "a",
      pswpModule: () => import("photoswipe"),
    });
    lightbox.init();

    return () => {
      lightbox.destroy();
      lightbox = null;
    };
  }, []);
  return (
    <div className="pswp-gallery" id={props.galleryID}>
      <a
        href={props?.images}
        data-pswp-width="1850"
        data-pswp-height="2500"
        key={props.galleryID}
        target="_blank"
        rel="noreferrer"
        className="eschool-award-cont-btn"
      >
        <Button className="eschool-btn secondary-btn">
          <i className="fi fi-ss-eye"></i>View certificate
        </Button>
      </a>
    </div>
  );
};

export default CertificateModal;
